Vue.prototype.DeviceNotFoundError = function(error) {
    this.name = 'DeviceNotFound';
    this.message = error || 'Device unavailable';
    this.stack = new Error().stack;
}
